export const transformTeacherListTableData = (
  teachersList: Array<any>
): any[] =>
  teachersList.map((teacher: any) => ({
    id: teacher.id,
    name: teacher.user.full_name,
    email: teacher.user.email,
    address: teacher.user.address,
    mobile: teacher.user.mobile,
    blockName: teacher.school_block.name,
    branchName: teacher.school_branch.name,
  }));
